import React from 'react';

import { Grid } from '@material-ui/core';

import QuickLogo from 'assets/Quick.svg';
import QuickERP from 'assets/QuickERP.png';

type GradientProps = {
  isScreenLarge: boolean;
};

export function GradientLogin({ isScreenLarge }: GradientProps) {
  return (
    <Grid
      container
      className="container-gradient"
      style={{
        backgroundColor: 'blue',
        height: '100%',
        width: '60%',
        display: isScreenLarge ? 'block' : 'none',
        backgroundImage: 'linear-gradient(180deg, #0370B2 0%, #2CB03B 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
    >
      <img
        className="image-gradient"
        src={QuickERP}
        style={{
          width: '100%',
          height: '100%',
          display: 'block',
          objectFit: 'cover',
          backgroundClip: 'text',
          color: 'transparent',
          // "-webkit-mask-image": "linear-gradient(to top, transparent 25%, black 100%)"
        }}
      />
      <img
        src={QuickLogo}
        style={{
          width: '90px',
          height: '109px',
          position: 'absolute',
          zIndex: 10,
          left: 50,
          top: 50,
        }}
      />
    </Grid>
  );
}
